export const PRICING_CURRENCY = 'CHF';
